import { ConsoleRequest, DataProviderType } from '../../utils/request';
import { TargetsBaseDataProvider } from './TargetsBaseDataProvider';
import { ConsoleRequestSettings, GetNodeChildrenRequest, GetNodeChildrenResponse, GetRootRequest, Node } from '../type';
import { DEFAULT_DATAPROVIDER_CONSOLE_REQUESTS } from '../type/TargetSettings';
import { Companies } from '@nirvana/shared/constants';

export class MDMDataProvider extends TargetsBaseDataProvider {
  public async getRootNode(payload: GetRootRequest, settings: ConsoleRequestSettings): Promise<Node> {
    try {
      const endpoint = settings.MDM?.rootNode?.endpoint ?? DEFAULT_DATAPROVIDER_CONSOLE_REQUESTS.MDM.rootNode.endpoint;
      const method = settings.MDM?.rootNode?.method ?? DEFAULT_DATAPROVIDER_CONSOLE_REQUESTS.MDM.rootNode.method;

      return await ConsoleRequest.createRequest<any>({
        dataProviderType: DataProviderType.MDM,
        endpoint: endpoint,
        method: method,
        payload: payload,
      });
    } catch (e) {
      throw new Error(e);
    }
  }

  public async getChildNodes(
    payload: GetNodeChildrenRequest,
    settings: ConsoleRequestSettings
  ): Promise<GetNodeChildrenResponse> {
    try {
      const endpoint =
        settings.MDM?.childNodes?.endpoint ?? DEFAULT_DATAPROVIDER_CONSOLE_REQUESTS.MDM.childNodes.endpoint;
      const method = settings.MDM?.childNodes?.method ?? DEFAULT_DATAPROVIDER_CONSOLE_REQUESTS.MDM.childNodes.method;

      return await ConsoleRequest.createRequest<any>({
        dataProviderType: DataProviderType.MDM,
        endpoint: endpoint,
        method: method,
        payload: payload,
      });
    } catch (e) {
      throw new Error(e);
    }
  }

  public getViewType(type: number): number {
    return 0;
  }

  public isLeafNode(node: Node, userMode: boolean, showOnlyCompanies: boolean, rootNodeId: string): boolean {
    const currentNodeIsRoot = node._id === rootNodeId;
    return !currentNodeIsRoot && node.type === Companies.TYPE_COMPANY && !node.specifics?.canBeManagedByAbove;
  }
}
